"use client";
import { useSidebar } from "@/features/core/hooks/useSidebar";
import Link from "next/link";
import React from "react";

export default function DashboardPage() {
  const { sidebar, validateRol } = useSidebar();

  return (
    <div className="min-h-screen bg-[#F5F7F6] p-10">
      {/* Header */}
      <h1 className="text-3xl font-bold text-[#E30613] mb-8 tracking-tight">
        Panel Principal
      </h1>

      {/* Grid of cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {sidebar.map(
          (item) =>
            validateRol(item) && (
              <Link
                key={item.key}
                href={item.path}
                className="group relative bg-white shadow-lg border border-gray-100 rounded-2xl p-6 flex flex-col items-center justify-center gap-4 text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#E30613]/10 text-[#E30613] group-hover:bg-[#E30613] group-hover:text-white transition-all duration-300">
                  {item.icon}
                </div>
                <span className="text-lg font-semibold text-[#5A4A49] group-hover:text-[#E30613] transition">
                  {item.label}
                </span>
              </Link>
            )
        )}
      </div>
    </div>
  );
}
